import React from 'react';
import {
    BasicSettings,BaseToolbarDimension,BaseToolbarMarginOrPadding, BaseToolbarInputGroup, BaseInput, BaseToolbarSelect, BaseToolbarJson,
} from 'wsc-react-custom-form';
export const FormUserSelectSettings = () => {
    return (
        <React.Fragment>
            {/* <BasicSettings /> */}
            <BaseToolbarDimension />
            <BaseToolbarMarginOrPadding name='margin' />
            <BaseToolbarMarginOrPadding name='padding' />

            <BaseToolbarInputGroup>
                {/*  widthRation可选：不填的话，label宽度占30%；填写的值在1-99之间*/}
                <BaseInput propKey='name' label='Name' tooltipTitle='存储表单值的key' widthRation={50} />
                <BaseInput propKey='label' label='Label' tooltipTitle='标签' widthRation={50} />
                <BaseToolbarSelect
                    propKey='showLabel'
                    label='显示Label'
                    tooltipTitle='是否显示标签'
                    options={[
                        { value: 'true', label: '显示' },
                        { value: 'false', label: '不显示' }
                    ]}
                    widthRation={50}
                />
                <BaseToolbarSelect
                    propKey='disabled'
                    label='禁用编辑'
                    tooltipTitle='是否禁用表单组件'
                    options={[
                        { value: 'true', label: '禁用' },
                        { value: 'false', label: '不禁用' }
                    ]}
                    widthRation={50}
                />
                <BaseToolbarSelect
                    propKey='multiple'
                    label='是否多选'
                    tooltipTitle='是否多选'
                    options={[
                        { value: 'true', label: '是' },
                        { value: 'false', label: '否' }
                    ]}
                    widthRation={50}
                />
                <BaseToolbarSelect
                    propKey='initial'
                    label='数据初始化'
                    tooltipTitle='数据初始化'
                    options={[
                        { value: 'true', label: '是' },
                        { value: 'false', label: '否' }
                    ]}
                    widthRation={50}
                />
                <BaseToolbarJson propKey="rules" label='校验规则' tooltipTitle='表单组件的校验规则' widthRation={50} />
                <BaseInput propKey='roleName' label='限定角色' tooltipTitle='限定角色' widthRation={50} />
                <BaseInput propKey='labelSpan' label='labelSpan' tooltipTitle='标签宽度（labelSpan）' widthRation={50} />
                <BaseInput propKey='labelOffset' label='labelOffset' tooltipTitle='标签偏移量（labelOffset）' widthRation={50} />
                <BaseInput propKey='wrapperSpan' label='wrapperSpan' tooltipTitle='表单组件宽度（wrapperSpan）' widthRation={50} />
                <BaseInput propKey='wrapperOffset' label='wrapperOffset' tooltipTitle='表单组件偏移量（wrapperOffset）' widthRation={50} />

            </BaseToolbarInputGroup>
        </React.Fragment>
    );
};
